import { createSlice } from '@reduxjs/toolkit';
import { ModeratorEntity } from '@interpals/api-web';

import { logout } from 'redux/auth/actions';

import { getModerator, getModerators } from './actions';

export interface ModeratorsState {
    moderators?: ModeratorEntity[];

    // Logged-in user's moderation entity (if exists).
    // Keeping separately from moderators array for access in multiple moderation
    // screens (not just mod list) and to avoid having to sort the moderator list.
    currentMod?: ModeratorEntity;
}

const initialState: ModeratorsState = {};

const moderatorsSlice = createSlice({
    name: 'moderators',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getModerators.fulfilled, (state, { payload: { data: moderators }, meta }) => {
            if (meta.arg.offset) {
                state.moderators = [...(state.moderators ?? []), ...moderators];
            } else {
                state.moderators = moderators;
            }

            // Update current mod if we received a new version of it
            if (state.currentMod) {
                const fetchedModerator = state.moderators.find((e) => e.user_id === state.currentMod?.user_id);

                if (fetchedModerator) {
                    state.currentMod = fetchedModerator;
                }
            }
        });

        builder.addCase(getModerator.fulfilled, (state, { payload: moderator }) => {
            state.currentMod = moderator;
        });

        builder.addCase(logout.fulfilled, () => {
            return initialState;
        });
    },
});

export default moderatorsSlice.reducer;
